import cx from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import styles from './TooltipOverlay.module.scss';
import { useState } from 'react';
import { icons } from '../../assets';
import { useSelector } from 'react-redux';
import {
  curatorActions,
  selectedIsImageScanSearchOnboardingData,
} from '../../redux/slicers/admin/curatorSlicer';
import { dispatcher } from '../../helpers/projectHelper';
import { objectToFormData, wait } from '../../helpers/jsHelper';
import { useUserContext } from '../../contexts/UserContext';
import { apiUpdateUserDetails } from '../../helpers/api';
import { isCuratorPage } from '../../helpers/urlHelper';
const { CrossIcon } = icons;

export const IMAGE_SEARCH_ONBOARDING_STEPS = [
  {
    id: 1,
    title: 'Now search your Props by uploading the images',
    curatorTitle: 'Now search your Products by uploading the images',
    position: 'bottom',
    className: 'customTooltipTop top-1',
  },
  {
    id: 2,
    title: 'After selecting the area, click on the button to search the prop',
    curatorTitle: 'After selecting the area, click on the button to search the product',
    position: 'top',
    className: 'customTooltipBottom',
  },
  {
    id: 3,
    title: 'Close the image search by clicking here',
    curatorTitle: 'Close the image search by clicking here',
    position: 'left',
    className: 'customTooltipRight',
  },
];

export const TooltipOverlay = ({ className = '', step, children, onClick }) => {
  const { currentUser, updateUserData } = useUserContext();
  const [showTooltip, setShowTooltip] = useState(false);
  const [isFirstTooltipReady, setIsFirstTooltipReady] = useState(false);
  const containerRef = useRef(null);

  const { steps, currentStep, isActive, isCompleted } = useSelector(
    selectedIsImageScanSearchOnboardingData
  );

  const removeDoubleTooltip = () => {
    const pageHeader = document.querySelectorAll('.pageHeader');
    if (pageHeader?.length > 0 && currentStep === 1) {
      const customTooltip = document.getElementsByClassName('customTooltipTop');
      for (let i = 0; i < pageHeader.length; i++) {
        if (
          pageHeader[i].classList.contains('static') &&
          !pageHeader[i].classList.contains('hidden')
        ) {
          if (customTooltip?.length > 1) {
            customTooltip[1].style.display = 'block';
            customTooltip[0].style.display = 'none';
          }
        } else if (
          !pageHeader[i].classList.contains('static') &&
          pageHeader[i].classList.contains('hidden')
        ) {
          if (customTooltip?.length > 1) {
            customTooltip[0].style.display = 'block';
            customTooltip[1].style.display = 'none';
          }
        }
      }
    }
  };

  useEffect(() => {
    if (!isFirstTooltipReady) return;
    const timer = setTimeout(() => {
      setShowTooltip(true);
    }, 3000);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isFirstTooltipReady]);

  useEffect(() => {
    if (currentStep === 1 && showTooltip) {
      removeDoubleTooltip();
      window.addEventListener('scroll', removeDoubleTooltip);
    }
    return () => window.removeEventListener('scroll', removeDoubleTooltip);
  }, [currentStep, showTooltip]);

  useEffect(() => {
    if (isActive && !isCompleted && +currentStep === +step) {
      const bodyHasPositionRelative = document.body.classList.contains('position-relative');
      if(!bodyHasPositionRelative) document.body.classList.add('position-relative');

      if (+currentStep === 1) {
        setIsFirstTooltipReady(true);
      } else {
        setShowTooltip(true);
      }
    } else {
      setShowTooltip(false);
      document.body.classList.remove('position-relative');
    }
  }, [isActive, isCompleted, currentStep, step]);

  const handleClose = async (e) => {
    e.stopPropagation();
    const _currentStep = currentStep + 1;
    setShowTooltip(false);
    if (steps.length >= _currentStep) {
      await wait(500);
      dispatcher(curatorActions.setImageScanSearchOnboardingData({ currentStep: _currentStep }));
    } else {
      dispatcher(
        curatorActions.setImageScanSearchOnboardingData({ isActive: false, isCompleted: true })
      );
      setShowTooltip(false);

      const payload = {
        other_info: JSON.stringify({
          ...currentUser?.user?.other_info,
          showImageSearchOnboarding: true,
        }),
      };
      const formData = objectToFormData(payload);
      await apiUpdateUserDetails(formData);
      updateUserData();
    }
  };

  const stepData = useMemo(() => {
    return steps.find((a) => +a.id === +currentStep) || {};
  }, [steps, currentStep]);

  return (
    <div key={step} ref={containerRef} onClick={onClick} className={className}>
      {children}
      {isActive && showTooltip ? (
        <Overlay
          key={step}
          target={containerRef.current}
          container={document.body}
          show={showTooltip}
          placement={stepData.position}>
          {({ ...props }) => (
            <Tooltip
              {...props}
              className={cx(styles.tooltip, stepData.className, 'customTooltip')}
              onClick={(e) => e.preventDefault()}>
              <p>{isCuratorPage() ? stepData.curatorTitle : stepData.title}</p>
              <div className={styles.close}>
                <CrossIcon onClick={handleClose} />
              </div>
            </Tooltip>
          )}
        </Overlay>
      ) : null}
    </div>
  );
};